import { Building2, Landmark, Globe2, HeartHandshake, Briefcase, GraduationCap } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Partners / clients band — institutional placeholder badges.
 * Replace with real client logos when available (admin upload).
 */
const PartnersBand = () => {
  const { t } = useLanguage();

  const partners = [
    { icon: Landmark, label: 'Administrations RDC' },
    { icon: Globe2, label: 'Bailleurs internationaux' },
    { icon: HeartHandshake, label: 'ONG & Coopération' },
    { icon: Building2, label: 'Banques & Assurances' },
    { icon: Briefcase, label: 'Secteur privé' },
    { icon: GraduationCap, label: 'Universités & Écoles' },
  ];

  return (
    <section className="py-16 bg-background border-y border-border">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <span className="inline-block text-primary font-semibold text-sm uppercase tracking-wider mb-2">
            {t('partners.subtitle')}
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground">
            {t('partners.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto">
          {partners.map((p, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center gap-2 p-5 rounded-xl bg-secondary/40 border border-border hover:border-accent/50 hover:bg-secondary transition-colors"
            >
              <p.icon className="w-8 h-8 text-primary" aria-hidden="true" />
              <span className="text-xs text-center text-muted-foreground font-medium leading-tight">
                {p.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersBand;
